import React from 'react';

type TableBadgeProps = {
  variant: string;
  children: React.ReactNode;
};

const TableBadge = ({ variant, children }: TableBadgeProps) => (
  <span className={`table-badge table-badge--${variant}`}>{children}</span>
);

export default TableBadge;
